module.exports = __webpack_public_path__ + "media/images/area/area_aomoriM400-4e5e07339b5f5640991083754446b5c5.jpg";